import styled, { css } from 'styled-components';

import Text, { TextProps } from '~components/Text';

export const S = {
  Base: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    padding: 40px 80px;
    width: 640px;
    text-align: center;

    ${({ theme }) => theme.media.mobile} {
      width: 100%;
      height: 100%;
      padding: 12px;
    }
  `,
  Header: styled.div`
    width: 100%;
    text-align: right;
  `,
  Title: styled.div``,
  SubTitle: styled(Text)<TextProps>`
    margin-top: 12px;
  `,
  ButtonGroup: styled.div`
    display: flex;
    align-items: center;
    margin-top: 20px;
    gap: 8px;
  `,
  Content: styled.div`
    margin-top: 12px;
  `,
};
